import { render } from "./FileStoragePreview.vue?vue&type=template&id=4dc01dac"
import script from "./FileStoragePreview.vue?vue&type=script&lang=js"
export * from "./FileStoragePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__